/// <amd-module name="Pipeline/Analytics/PipelineOutcome/PassRateTrendCard/Actions/PipelineOutcomePassRateTrendActions" />
import { PipelineReportBaseActions } from "Pipeline/Analytics/Common/Actions/PipelineReportBaseActions";
import { IPipelineOutcomeData } from "Pipeline/Analytics/Common/Types";

export class PipelineOutcomePassRateTrendActions extends PipelineReportBaseActions<IPipelineOutcomeData> {}
